import { ComponentPropsWithoutRef } from 'react';
import { motion } from 'motion/react';
import { Dialog as Primitive } from 'radix-ui';

export type DialogOverlayProps = ComponentPropsWithoutRef<typeof motion.div>;

export function DialogOverlay(props: DialogOverlayProps) {
  return (
    <Primitive.Overlay asChild>
      <motion.div {...props} />
    </Primitive.Overlay>
  );
}
